<template>
  <div>
    <div class="inner_banner">
      <img src="~@/assets/image/casebanner.jpg" />
      <div class="container bannertxt casetext">
        <div>
          <div class="banner_title">案例中心</div>
          <div class="banner_sub_title">展特易/案例中心</div>
        </div>
      </div>

    </div>
    <div class="zqrow">
      <div class="content container">
        <div class="zq_left">

          <ul class="cate_ul">
            <div class="title">所有服务</div>
            <li class="hasbord" v-for="(item,i) in allcatList" v-bind:class={active:item.active?item.active:false}>
              <div class="cate_name"
                   v-bind:class={active:item.active,has_son:item.child.length?item.child.length:0}
                   @click="open_nav(i)">{{item.type_name}}</div>

              <ul class="son" v-for="it in item.child">
                <el-collapse-transition>
                  <li @click="selectCat(it.id)" class="transition-box" v-show="!item.active">
                    <div class="cate_name">{{it.type_name}}</div>
                  </li>
                </el-collapse-transition>
              </ul>

            </li>



            <!-- <div class="spilt_bj"></div>
            <div class="title_choose">筛选</div>
            <div class="tag_list">
              <div class="tag" @click="selectParams('all')"><img
                  src="~@/assets/image/chooseclose.svg" />清除所有标签</div>
            </div>
            <div class="choose_group">
              <div class="choose_item" v-for="param in allParameters">
                <div class="choose_item_name">{{param.name}}</div>
                <ul class="choose_list">
                  <li v-for="(item,i) in param.value" @click="selectParams(item)">
                    <div class="choose_btn" v-bind:class={on:isparam(item)}>
                      <img src="~@/assets/image/k.svg" />
                    </div>
                    <div class="choose_item_li_name">{{item}}</div>
                    <div class="choose_num"></div>
                  </li>
                </ul>
              </div>
            </div> -->
          </ul>
        </div>
        <div class="zq_right">
          <!--					<div class="first_product_card">-->
          <!--						<div class="zq_left">-->
          <!--							<div class="cate_card">-->
          <!--								<img v-bind:src="banner" />-->
          <!--							</div>-->
          <!--						</div>-->
          <!--						<div class="zq_right">-->
          <!--							<div class="des">-->
          <!--								<div class="title">{{curcatename}}</div>-->
          <!--								<div class="inner_des">{{readme}}</div>-->
          <!--							</div>-->

          <!--						</div>-->
          <!--					</div>-->
          <div class="search-tip">
            <div class="search_word">搜索到{{totalPro}}个相关产品</div>
            <div>

            </div>
          </div>
          <!-- <div class="sreach_res">
            <div class="text">筛选标签</div>
            <div class="search_list">
              <div class="search_res_tag" v-for="(item,i) in paramsList" v-if="isparam(item)"
                @click="selectParams(item)">{{item}}</div>
            </div>
          </div> -->
          <div class="product_list" v-loading="loadingShow">

            <div class="case_item" v-for="(good) in articleList" :key="good.id">
              <router-link :to="{name:'casedetail',params: {goodsId:good.id}}">
                <div class="product_item_img">
                  <div class="product_item_img_cell">
                    <img v-bind:src="good.cover" />
                    <div class="casetitle">{{good.title}}</div>
                  </div>

                </div>

              </router-link>
            </div>




          </div>
        </div>
      </div>
    </div>

    <template v-if="goodsList.length>0">
      <Pagination :totalPage="totalPage" :limit="searchOptions.limit" @changePage="handleCurrentChange">
      </Pagination>
    </template>

  </div>
</template>
<script>
import Pagination from "@/components/common/Pagination.vue";
import {
  deepCopy
} from "@/utils";
import {
  goodsStyle
} from "@/utils";
import {
  forEach
} from "core-js/fn/dict";
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition';
export default {
  name: "Case",
  components: {
    Pagination
  },
  props: {},
  data() {
    return {
      loadingShow: false,
      articleList:[],
      totalPage: 0,
      goodsList: [],
      showFilter: true,
      firstLoad: true, //是否初次加载
      catList: [], //分类
      allcatList: [], //所有分类,
      brandList: [], //品牌
      labelList: [], //筛选标签
      paramsList: [],
      noDataIsShow: false,
      loadingShow: false,
      banner: require("@/assets/image/first_pro.png"),
      readme: "",
      curcatename: "",
      allParameters: [],
      isopen: false,
      searchOptions: {
        where: {},
        limit: 15,
        page: 1,
        order: {
          key: "sort",
          sort: "asc" //默认综合排序
        }
      },
      totalPro: 0,
    };

  },
  watch: {},
  computed: {
  },
  methods: {
    open_nav: function(k) {
      this.$set(this.allcatList[k], 'active', !this.allcatList[k].active)
    },
    //搜索分类
    selectCat(id) {
      let data = {
        page: 1,
        where: {
          cat_id: id
        }
      };
      console.log("data",data);
      this.selectedCatId = id;
      this.getArticleList(id);
    },
    isparam(id) {
      let index = this.paramsList.indexOf(id);
      console.log("index",index);
      if (index > -1) {
        return true;
      } else {
        return false;
      }
    },
    getArticleList(type_id) {
      let where = {
        type_id: type_id,
        limit:1000,
      };
      this.$api.articleList(where).then(res => {
        if (res.status) {
          this.articleList = res.data.list;
          console.log("this.articleList", this.articleList);
        }
      })
    },
    // 获取文章所有分类
    getArticleNav() {
      let where = {
        id: 1,

      };
      this.$api.articleTypeList(where).then(res => {
        if (res.status) {
          this.allcatList = res.data.list[1]['child'] && res.data.list ? res.data.list[1]['child'] : "";
          console.log("this.allcatList", this.allcatList);
        }
      })
    },



    //搜索品牌
    selectParams(id) {
      if (id == "all") {
        this.paramsList = [];
      } else {
        let index = this.paramsList.indexOf(id);
        console.log("indexindex",index);
        if (index > -1) {
          this.paramsList.splice(index, 1);
          delete this.searchOptions.where.params;
        } else {
          this.paramsList.push(id);
        }
      }

      let	 data = {
        page: 1,
        where: {
          params: this.paramsList
        }
      };

      console.log("this.paramsListdata",data);
      this.setSearchOptions(data, true);
      this.getGoodsList();
    },


    //设置筛选条件
    setSearchOptions: function(searchData, clear = false) {
      var sd = this.searchOptions;
      this.searchOptions = deepCopy(sd, searchData);
      if (clear) {
        this.goodsList = [];
      }
    },
    //分页
    handleCurrentChange(val) {
      console.log("val", val);
      this.setSearchOptions({
        page: val
      });
      this.getGoodsList();
    },
    handleParamsData(query) {
      console.log("handleParamsData");
      let where = {};
      if (query.key) {
        where = {
          search_name: query.key
        };
      }
      if (query.id) {
        where = {
          cat_id: query.id
        };
      }
      if (query.type) {
        if (query.type == "hot") {
          where = {
            hot: true
          };
        }
        if (query.type == "recommend") {
          where = {
            recommend: true
          };
        }
      }
      this.setSearchOptions({
        where: where
      });


      // this.categoriesTypeval();
      this.getAllParameters();
    },
    getAllParameters() {
      this.$api.getAllParameters().then(res => {
        if (res.status) {
          this.allParameters = res.data;
        }
      })
    },
    //获取商品列表

  },
  created() {
    let query = this.$route.query;
    console.log("query", query);
    this.handleParamsData(query);
    this.getArticleList();
    this.getArticleNav();
  },
  mounted() {


  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/product.scss";
@import "@/assets/css/case.scss";
.inner_banner > img{
  width: 100%;
}
</style>
